export default "__VITE_ASSET__BwFvWEjY__"